import { render, staticRenderFns } from "./SaveOrganization.vue?vue&type=template&id=48a27514&scoped=true&"
import script from "./SaveOrganization.vue?vue&type=script&lang=js&"
export * from "./SaveOrganization.vue?vue&type=script&lang=js&"
import style0 from "./SaveOrganization.vue?vue&type=style&index=0&id=48a27514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a27514",
  null
  
)

export default component.exports